import { BaseApiService } from "../../base-api-service";
import { ApiVersions } from "../../../enums";
import { env } from "../../../environment";
import {
  BalanceRequestData,
  BalanceMonitoringParams,
  BalanceMonitoringResponse,
  BalanceTransactionRequestParams,
  BalanceTransactionRequestsResponse
} from "../../../models";

class TransactionsController extends BaseApiService {

  public async getBalanceTransactionRequests(params: BalanceTransactionRequestParams): Promise<BalanceTransactionRequestsResponse> {
    let url = `${this.url}/api/${ApiVersions.V1}/wallet/balance-transaction-requests`;
    return await this.http.get(url, { params });
  }

  public async getBalanceMonitoringTransactions(params: BalanceMonitoringParams): Promise<BalanceMonitoringResponse> {
    let url = `${this.url}/api/${ApiVersions.V1}/wallet/balance-transactions`;
    return await this.http.get(url, { params });
  }

  public async balanceRequestApproveOrReject(data: BalanceRequestData): Promise<BalanceMonitoringResponse> {
    let url = `${this.url}/api/${ApiVersions.V1}/wallet/balance-transaction-request`;
    return await this.http.put(url, data);
  }

}

export const transactionsController = new TransactionsController({ url: env.httpUrl });